export default "__VITE_ASSET__DuARFa67__"